import { Injectable } from '@angular/core';

declare var moment;

import {
  PaxFormControlBase,
  PaxFormControlTextbox,
  PaxFormControlDropdown,
  PaxFormControlDatepicker,
  PaxFormControlRadio
} from './../../shared/index';

@Injectable()
export class FormDriverInformationService {

  getQuestions() {

    // todo: get data from store?
    let questions: PaxFormControlBase<any>[] = [

      // First Name
      new PaxFormControlTextbox({
        key: 'driverFirstName',
        label: 'First name',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Last Name
      new PaxFormControlTextbox({
        key: 'driverLastName',
        label: 'Last name',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2
      }),

      // DOB
      new PaxFormControlDatepicker({
        key: 'dob',
        label: 'DOB',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 3
      }),

      // LIc #
      new PaxFormControlTextbox({
        key: 'licNumber',
        label: 'LIc #',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 4
      }),

      // State Licensed
      new PaxFormControlDropdown({
        key: 'stateLicensed',
        label: 'State Licensed',
        options: [
          { key: 'al', value: 'Alabama' },
          { key: 'ak', value: 'Alaska' },
          { key: 'az', value: 'Arizona' },
          { key: 'ar', value: 'Arkansas' },
          { key: 'ca', value: 'California' },
          { key: 'co', value: 'Colorado' },
          { key: 'ct', value: 'Connecticut' },
          { key: 'de', value: 'Delaware' },
          { key: 'fl', value: 'Florida' },
          { key: 'ga', value: 'Georgia' },
          { key: 'hi', value: 'Hawaii' },
          { key: 'id', value: 'Idaho' },
          { key: 'il', value: 'Illinois' },
          { key: 'in', value: 'Indiana' },
          { key: 'ia', value: 'Iowa' },
          { key: 'ks', value: 'Kansas' },
          { key: 'ky', value: 'Kentucky[D]' },
          { key: 'la', value: 'Louisiana' },
          { key: 'me', value: 'Maine' },
          { key: 'md', value: 'Maryland' },
          { key: 'ma', value: 'Massachusetts[E]' },
          { key: 'mi', value: 'Michigan' },
          { key: 'mn', value: 'Minnesota' },
          { key: 'ms', value: 'Mississippi' },
          { key: 'mo', value: 'Missouri' },
          { key: 'mt', value: 'Montana' },
          { key: 'ne', value: 'Nebraska' },
          { key: 'nv', value: 'Nevada' },
          { key: 'nh', value: 'New Hampshire' },
          { key: 'nj', value: 'New Jersey' },
          { key: 'nm', value: 'New Mexico' },
          { key: 'ny', value: 'New York' },
          { key: 'nc', value: 'North Carolina' },
          { key: 'nd', value: 'North Dakota' },
          { key: 'oh', value: 'Ohio' },
          { key: 'ok', value: 'Oklahoma' },
          { key: 'or', value: 'Oregon' },
          { key: 'pa', value: 'Pennsylvania[F]' },
          { key: 'ri', value: 'Rhode Island[G]' },
          { key: 'sc', value: 'South Carolina' },
          { key: 'sd', value: 'South Dakota' },
          { key: 'tn', value: 'Tennessee' },
          { key: 'tx', value: 'Texas' },
          { key: 'ut', value: 'Utah' },
          { key: 'vt', value: 'Vermont' },
          { key: 'va', value: 'Virginia[H]' },
          { key: 'wa', value: 'Washington' },
          { key: 'wv', value: 'West Virginia' },
          { key: 'wi', value: 'Wisconsin' },
          { key: 'wy', value: 'Wyoming' },
          { key: 'dc', value: 'District of Columbia' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 5
      }),

      // Are you currently insured?
      new PaxFormControlRadio({
        key: 'areYouCurrentlyInsured',
        label: 'Are you currently insured?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 6
      }),

    ];

    return questions.sort((a, b) => a.order - b.order);
  }

  getClaimsQuestions() {
    let questions: PaxFormControlBase<any>[] = [
      new PaxFormControlDatepicker({
        key: 'claimDate',
        label: '',
        layout: 'full',
        order: 1,
        settings: {}
      }),
      new PaxFormControlTextbox({
        key: 'claimDesctiprion',
        label: '',
        layout: 'full',
        order: 2
      }),
    ];
    return questions.sort((a, b) => a.order - b.order);
  }

  getAccidentQuestion() {
    let now = moment();
    let datepickerLimit = now.subtract(35, 'months');
    let questions: PaxFormControlBase<any>[] = [
      new PaxFormControlDropdown({
        key: 'violationType',
        label: '',
        options: [
          { key: 'AAF', value: 'AAF - At Fault Accident' },
          { key: 'BOT', value: 'BOT - Open Bottle/Container' },
          { key: 'CRD', value: 'CRD - Careless/Improper Op of Vehicle' },
          { key: 'DEQ', value: 'DEQ - Defective Equipment' },
          { key: 'DEV', value: 'DEV - Disregard Traffic Device/Sign' },
          { key: 'DR', value: 'DR  - Drag Racing' },
          { key: 'DWI', value: 'DWI - Driving Under the Influence' },
          { key: 'EQP', value: 'EQP - Equipment Violations' },
          { key: 'FAR', value: 'FAR - False Report to Official/Perjury' },
          { key: 'FEL', value: 'FEL - Auto Theft / Felony' },
          { key: 'FRA', value: 'FRA - Failure to Report Accident' },
          { key: 'FTC', value: 'FTC - Following Too Close' },
          { key: 'FTY', value: 'FTY - Failure to Yield' },
          { key: 'IBK', value: 'IBK - Improper Backing' },
          { key: 'IP', value: 'IP  - Improper Passing' },
          { key: 'IT', value: 'IT  - Improper Turn/U-Turn' },
          { key: 'LIC', value: 'LIC - License/Credentials Violation' },
          { key: 'LTS', value: 'LTS - Leaving the Scene' },
          { key: 'MMV', value: 'MMV - Other Minor Moving Violations' },
          { key: 'NAF', value: 'NAF - Not At Fault Accident' },
          { key: 'REF', value: 'REF - Refusal to Test' },
          { key: 'RKD', value: 'RKD - Reckless Driving' },
          { key: 'SAF', value: 'SAF - Safety Violation' },
          { key: 'SCH', value: 'SCH - Passing School Bus' },
          { key: 'SPD', value: 'SPD - Speeding' },
          { key: 'SUS', value: 'SUS - Driving w/ Susp/Rev/Canc License' },
          { key: 'WOC', value: 'WOC - Operate w/o Owner\'s Consent' },
          { key: 'WSR', value: 'WSR - Wrong Side of Road' },
        ],
        layout: 'full',
        order: 1
      }),
      new PaxFormControlDatepicker({
        key: 'violationDate',
        label: '',
        layout: 'full',
        order: 2,
        settings: {
          disableUntil: {
            year: datepickerLimit.get('year'),
            month: datepickerLimit.get('month') + 1, // + 1 because of API's inconsistencies between moment and mydatepicker
            day: datepickerLimit.get('date')
          }
        }
      })
    ];

    return questions.sort((a, b) => a.order - b.order);
  }

  getCurrentlyInsured() {
    let questions: PaxFormControlBase<any>[] = [

      // Current Carrier
      new PaxFormControlTextbox({
        key: 'currentCarrier',
        label: 'Current Carrier',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Policy #
      new PaxFormControlTextbox({
        key: 'policyNumber',
        label: 'Policy #',
        order: 2
      }),

      // Exp Date
      new PaxFormControlDatepicker({
        key: 'expDate',
        label: 'Exp Date',
        order: 3,
        settings: {}
      })

    ];
    return questions.sort((a, b) => a.order - b.order);
  }

  getCurrentlyNotInsured() {
    let questions: PaxFormControlBase<any>[] = [

      // Reason for No prior insurance
      new PaxFormControlDropdown({
        key: 'noPriorInsurance',
        label: 'Reason for No prior insurance',
        options: [
          { key: 'newPurchase', value: 'New Purchase' },
          { key: 'truckInsuredOnMotorCarrierPolicy', value: 'Truck insured on Motor Carrier Policy' },
          { key: 'parkedDidNotWork', value: 'Parked - did not work' },
          { key: 'оther', value: 'Other' },
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),
    ];
    return questions.sort((a, b) => a.order - b.order);
  }

  // Other reason for no prior insurance
  getQuestionOtherReasonForNoPriorInsurance(): PaxFormControlBase<any> {
    return new PaxFormControlTextbox({
      key: 'noPriorInsuranceOther',
      label: 'Other',
      validation: [{
        name: 'required',
        condition: true,
        message: 'Field is required'
      }],
      order: 1
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-driver-information/form-driver-information.service.ts